export const isStoryblokEditMode = (route: { query: Record<string, unknown> }) =>
  !!route?.query?.['_storyblok'];
